type IconProps = {
  name?: string;
}

const Icon = ({ name }: IconProps) => {
  return <i className={`icon-${name}`}></i>
}

export default Icon;